import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TooltipDirective, TooltipOverflowDirective } from '@ideals/ui-components/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, TooltipOverflowDirective],
  selector: 'ideals-help-article',
  styleUrls: ['./help-article.component.scss'],
  templateUrl: './help-article.component.html',
})
export class HelpArticleComponent {
  readonly title = input<string>();
  readonly url = input<string>();
}
